import { render } from "./gameOverview.vue?vue&type=template&id=4e092994&scoped=true"
import script from "./gameOverview.vue?vue&type=script&lang=js"
export * from "./gameOverview.vue?vue&type=script&lang=js"

import "./gameOverview.vue?vue&type=style&index=0&id=4e092994&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e092994"]])

export default __exports__